import { render } from "./Gala.vue?vue&type=template&id=71863c73"
import script from "./Gala.vue?vue&type=script&lang=js"
export * from "./Gala.vue?vue&type=script&lang=js"
script.render = render

export default script